<template>
  <div class="content">
    <div class="login-title">
      SMS verification login
    </div>
    <div class="phone-box" style="margin-top: 91px">
      <div class="eight-six">
        +86
      </div>
      <img src="../assets/mq_arrow_down_icon.png" class="arrow-icon">
      <input onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" placeholder="Mobile number" class="input-style" v-model="phone"/>
    </div>
    <div class="phone-box">
      <input onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" type="password" class="input-style" placeholder="Verification code" style="margin-left: 18px" v-model="verifiedCode">
      <div class="line" />
      <div class="getVerifyCode" @click="getVerifyCode"  v-if="show">
        Get  code
      </div>
      <div class="getVerifyCode"  v-else>
        {{times}}
      </div>
    </div>
    <div class="login-button" @click="confirm">
      ok
    </div>
  </div>
</template>

<script>
import {postAction} from '../network/GetAndPost'
import Vue from 'vue'

export default {
  name: 'CAPTCHALogin',
  methods: {
    getVerifyCode () {
      if(this.phone.length !== 11){
        alert("phone number not correct")
      }else {
        let that = this
        postAction(this.sendCodeUrl, {'phone': this.phone, 'area': this.area}).then((res) => {
          if(res.status === 200){
            that.show = false
            that.timer = setInterval(()=>{
              that.times--
              if(that.times===0){
                that.show = true
                clearInterval(that.timer)
              }
            },1000)
          }
        })
      }
    },
    confirm () {
      postAction(this.verificationLogin, {"phone": this.area+this.phone, "code": this.verifiedCode }).then((res)=>{
        if(res.status === 200){
          Vue.ls.set("Access-Token",res.result.token,60 * 60 * 1000 * 24 * 14)
          Vue.ls.set("userInfo",res.result,60 * 60 * 1000 * 24 * 14)
          this.$router.push({name:'personalMain'})
        }else {
          alert(res.message)
        }
      })
    }
  },
  data () {
    return {
      times: 60,
      show: true,
      phone: '',
      area: '+86',
      verifiedCode: '',
      sendCodeUrl: '/index/index/sendCode',
      verificationLogin: '/index/index/verificationLogin'
    }
  }
}
</script>

<style scoped>
.getVerifyCode{
  font-size: 20px;
  font-weight: 400;
  color: #009CEE;
  line-height: 28px;
  margin-left: 18px;
  cursor: pointer;
}
.line{
  width: 1px;
  height: 20px;
  background:  #E8E8E8;
  margin-left: 60px;
}
.content{
  width: 647px;
  height: 700px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.forget-password{
  margin-top: 48px;
  font-size: 18px;
  font-weight: 400;
  color: #009CEE;
  line-height: 25px;
}
.register-button{
  margin-top: 20px;
  width: 457px;
  height: 60px;
  border: 1px solid #009CEE;
  font-size: 22px;
  font-weight: 500;
  color: #009CEE;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.login-button{
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 30px;
  width: 460px;
  height: 60px;
  background: #009CEE;
  cursor: pointer;
}
.auto-login{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
}
.input-style{
  background:none;
  outline:none;
  border:none;
  font-size: 20px;
  font-weight: 500;
  color: #000000;
  line-height: 28px;
  margin-left: 14px;
}
.arrow-icon{
  margin-left: 15px;
  width: 21px;
  height: 13px;
}
.eight-six{
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  line-height: 28px;
  margin-left: 18px;
}
.phone-box{
  margin-top: 20px;
  width: 459px;
  height: 60px;
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  display: flex;
  align-items: center;
}
.verify-button{
  font-size: 18px;
  font-weight: 400;
  color: #009CEE;
  line-height: 25px;
}
.verify-code{
  margin-top: 46px;
  width: 460px;
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.login-title{
  margin-top: 67px;
  font-size: 28px;
  font-weight: 600;
  color: #000000;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/CAPTCHALogin.vue